/* AN: Gift card page.
   Keeps the postcard, the amount, the message and the date in step, and keeps
   the hidden inputs that ride to the cart in step with them.
   Everything degrades to a plain form post if this never runs. */
(function () {
  function init(root) {
    if (!root || root.dataset.anReady === '1') return;
    root.dataset.anReady = '1';

    var q = function (s) { return root.querySelector(s); };
    var qa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    var faces = qa('[data-an-gc-face]');
    var swatches = qa('[data-an-gc-design]');
    var amounts = qa('[data-an-gc-amount]');
    var dates = qa('[data-an-gc-when]');
    var flip = q('[data-an-gc-flip]');
    var picker = q('[data-an-gc-picker]');
    var msg = q('[data-an-gc-msg]');
    var fmt = root.getAttribute('data-money-format') || '${{amount}}';

    var side = 'front';
    var design = null;

    function money(cents) {
      var v = (cents / 100).toFixed(2).replace(/\.00$/, '');
      return fmt.replace(/\{\{\s*amount[^}]*\}\}/, v);
    }

    /* --- the card ------------------------------------------------------- */
    function paintCard() {
      var hasBack = false;
      faces.forEach(function (f) {
        var mine = f.getAttribute('data-design') === design;
        if (mine && f.getAttribute('data-an-gc-face') === 'back') hasBack = true;
        f.hidden = !(mine && f.getAttribute('data-an-gc-face') === side);
      });
      if (flip) flip.hidden = !hasBack;
      if (!hasBack && side === 'back') { side = 'front'; paintCard(); }
    }

    function choose(btn) {
      design = btn.getAttribute('data-an-gc-design');
      swatches.forEach(function (s) {
        var on = s === btn;
        s.classList.toggle('is-on', on);
        s.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var name = btn.getAttribute('data-name') || '';
      var chosen = q('[data-an-gc-chosen]');
      if (chosen) chosen.textContent = name ? '· ' + name : '';
      var hn = q('[data-an-gc-designname]'); if (hn) hn.value = name;
      var hh = q('[data-an-gc-designhandle]'); if (hh) hh.value = design;
      side = 'front';
      qa('[data-an-gc-side]').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-an-gc-side') === 'front'); });
      paintCard();
      paintEmail();
    }

    swatches.forEach(function (s) { s.addEventListener('click', function () { choose(s); }); });
    qa('[data-an-gc-side]').forEach(function (b) {
      b.addEventListener('click', function () {
        side = b.getAttribute('data-an-gc-side');
        qa('[data-an-gc-side]').forEach(function (o) { o.classList.toggle('is-on', o === b); });
        paintCard();
      });
    });

    /* --- amount --------------------------------------------------------- */
    function pickAmount(btn) {
      amounts.forEach(function (a) {
        var on = a === btn;
        a.classList.toggle('is-on', on);
        a.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var cents = parseInt(btn.getAttribute('data-an-gc-amount'), 10);
      var vid = btn.getAttribute('data-variant');
      var hv = q('[data-an-gc-variant]');
      if (hv && vid) hv.value = vid;
      var out = q('[data-an-gc-submitamt]');
      if (out) out.textContent = '· ' + money(cents);
      var note = q('[data-an-gc-amountnote]');
      /* Each amount carries its own line, set per amount in the section settings. */
      var buys = btn.getAttribute('data-buys');
      var wrap = note ? note.parentNode : null;
      if (note && buys) {
        note.textContent = money(cents) + ' buys ' + buys;
        if (wrap) wrap.hidden = false;
      } else if (wrap) {
        wrap.hidden = true;
      }
      var submit = q('[data-an-gc-submit]');
      if (submit) submit.disabled = !vid;
      paintEmail();
    }
    var noteEl = q('[data-an-gc-amountnote]');
    if (noteEl) noteEl.dataset.tpl = noteEl.textContent;
    amounts.forEach(function (a) { a.addEventListener('click', function () { pickAmount(a); }); });

    /* --- message count -------------------------------------------------- */
    if (msg) {
      var count = q('[data-an-gc-count]');
      var tick = function () { if (count) count.textContent = msg.value.length; };
      msg.addEventListener('input', tick);
      tick();
    }

    /* --- when ----------------------------------------------------------- */
    function pickWhen(btn) {
      dates.forEach(function (d) {
        var on = d === btn;
        d.classList.toggle('is-on', on);
        d.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var when = btn.getAttribute('data-an-gc-when');
      var note = q('[data-an-gc-whennote]');
      if (note) note.textContent = btn.getAttribute('data-note') || '';
      if (picker) picker.hidden = when !== 'pick';

      var label = q('[data-an-gc-whenlabel]');
      var value = q('[data-an-gc-whenvalue]');
      if (when === 'today') {
        if (label) label.value = btn.textContent.trim();
        if (value) value.value = '';
      } else if (when === 'pick') {
        if (label) label.value = picker && picker.value ? picker.value : 'A date you choose';
        if (value) value.value = picker ? picker.value : '';
      } else {
        if (label) label.value = btn.textContent.trim();
        if (value) value.value = when;
      }
    }
    dates.forEach(function (d) { d.addEventListener('click', function () { pickWhen(d); }); });
    if (picker) picker.addEventListener('change', function () {
      var on = root.querySelector('[data-an-gc-when].is-on');
      if (on) pickWhen(on);
    });

    /* --- what they receive ---------------------------------------------- */
    var gce = {
      from: document.querySelector('[data-an-gce-from]'),
      sign: document.querySelector('[data-an-gce-sign]'),
      greeting: document.querySelector('[data-an-gce-greeting]'),
      msg: document.querySelector('[data-an-gce-msg]'),
      img: document.querySelector('[data-an-gce-img]'),
      amounts: Array.prototype.slice.call(document.querySelectorAll('[data-an-gce-amount]'))
    };
    var msgDefault = gce.msg ? gce.msg.textContent : '';

    function paintEmail() {
      var to = q('[data-an-gc-to]');
      var from = q('[data-an-gc-from]');
      var toName = to && to.value.trim();
      var fromName = from && from.value.trim();

      if (gce.from) gce.from.textContent = fromName || 'Someone';
      if (gce.sign) gce.sign.textContent = fromName || 'you';
      if (gce.greeting) gce.greeting.textContent = toName ? 'Dear ' + toName + ',' : 'Dear friend,';
      if (gce.msg) gce.msg.textContent = (msg && msg.value.trim()) || msgDefault;

      var on = root.querySelector('[data-an-gc-amount].is-on');
      if (on && gce.amounts.length) {
        var txt = money(parseInt(on.getAttribute('data-an-gc-amount'), 10));
        gce.amounts.forEach(function (el) { el.textContent = txt; });
      }

      var face = root.querySelector('[data-an-gc-face="front"][data-design="' + design + '"]');
      if (gce.img) {
        if (face) { gce.img.src = face.src; gce.img.alt = face.alt; gce.img.hidden = false; }
        /* No postcard to show, so take the empty mount away rather than leave a
           white sliver where a picture should be. */
        var frame = gce.img.parentElement;
        if (frame) frame.hidden = !face;
      }
    }

    ['[data-an-gc-to]', '[data-an-gc-from]', '[data-an-gc-msg]'].forEach(function (sel) {
      var el = q(sel);
      if (el) el.addEventListener('input', paintEmail);
    });

    /* --- opening state -------------------------------------------------- */
    var wanted = null;
    try { wanted = new URLSearchParams(location.search).get('design'); } catch (e) {}
    var first = null;
    if (wanted) first = swatches.filter(function (s) { return s.getAttribute('data-an-gc-design') === wanted; })[0];
    if (!first) first = swatches[0];
    if (first) choose(first);

    var sellable = amounts.filter(function (a) { return a.getAttribute('data-variant'); });
    /* Fall back to showing an amount even when nothing is sellable yet, so the
       page reads properly while the product is still being set up. The submit
       stays disabled either way. */
    var startAmount = sellable[1] || sellable[0] || amounts[1] || amounts[0];
    if (startAmount) pickAmount(startAmount);
    var dead = q('[data-an-gc-submit]');
    if (dead && !sellable.length) dead.disabled = true;
    paintEmail();
  }

  function boot() { Array.prototype.slice.call(document.querySelectorAll('[data-an-gc]')).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();


/* ---- Add to cart in place, and open the theme's cart drawer ----
   The form was a plain post to the cart route, so the browser left the page
   for /cart. Everything else in Symmetry opens the drawer. If anything here
   fails, or the theme has no drawer, the normal post still happens. */
(function () {
  var form = document.querySelector('[data-an-gc-form]');
  if (!form || !window.fetch || !window.FormData) return;
  var submit = form.querySelector('[data-an-gc-submit]');

  form.addEventListener('submit', function (e) {
    if (!document.querySelector('cart-drawer')) return;
    e.preventDefault();
    if (submit) submit.disabled = true;

    fetch(form.action + '.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        /* Refresh first, then open on the next tick. Firing both in the same
           turn loses the open, because the refresh rebuilds the drawer. */
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        setTimeout(function () {
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
        }, 250);
        if (submit) submit.disabled = false;
      })
      .catch(function () { form.submit(); });
  });
})();


/* Shopify needs the buyer's timezone offset to schedule 'Send on' in their
   local day rather than the shop's. Harmless if absent, so this is best effort. */
(function () {
  var el = document.querySelector('[data-an-gc-offset]');
  if (el) { try { el.value = String(new Date().getTimezoneOffset()); } catch (e) {} }
})();
